import { TAppState } from '../../types/appState';

export function chatActionModalSelector(state: TAppState) {
  return state.chatActionModal;
}
